module.exports = __webpack_public_path__ + "img/c-title.fbc43e8f.png";